import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useStockItems } from "@/lib/useStockItems";
import { TransactionsTab } from "@/components/stock/TransactionsTab";
import { StockSummaryTab } from "@/components/stock/StockSummaryTab";

const tabCls = "data-[state=active]:bg-slate-900 data-[state=active]:text-white";

export default function Inventory() {
  const { t } = useLang();
  const { items, reload } = useStockItems();
  return (
    <div className="space-y-6" data-testid="inventory-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>{t("inventory")}</h1>
        <p className="text-sm text-slate-500 mt-1">{t("inventory_desc")}</p>
      </div>
      <Tabs defaultValue="transactions">
        <TabsList className="bg-slate-100">
          <TabsTrigger value="transactions" className={tabCls} data-testid="tab-transactions">{t("transactions")}</TabsTrigger>
          <TabsTrigger value="summary" className={tabCls} data-testid="tab-stock-summary">{t("stock_summary")}</TabsTrigger>
        </TabsList>
        <TabsContent value="transactions" className="mt-4"><TransactionsTab items={items} reloadItems={reload} /></TabsContent>
        <TabsContent value="summary" className="mt-4"><StockSummaryTab /></TabsContent>
      </Tabs>
    </div>
  );
}
